<template>
  <v-navigation-drawer
    v-model="drawer"
    class="nav-drawer"
    app
    width="270"
    @input="drawerClose"
    :mobile-breakpoint="SIDEBAR_MOBILEBREAKPOINT_WIDTH"
  >
    <v-app-bar class="thick-border-top" fixed clipped-top>
      <v-toolbar-title class="mr-5 align-center">
        <v-img :src="require('@/assets/img/logo.png')" class="ma-2" contain height="40" />
      </v-toolbar-title>
    </v-app-bar>

    <v-layout class="nav-content">
      <v-layout class="nav-inner-content pl-0">
        <v-list dense expand>
          <v-list-group :value="true" no-action>
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("global.sb_main_menu") }}</v-list-item-title>
            </template>

            <!-- MAIN -->
            <span v-for="item in items.main" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>

          <v-list-group :value="true" no-action v-if="show_brakomp_menu">
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("global.sb_xl3_menu") }}</v-list-item-title>
            </template>

            <!-- BRAKOMP -->
            <span v-for="item in items.brakomp" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>

          <v-list-group :value="true" no-action v-if="show_brareg_menu">
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("global.sb_certreg_menu") }}</v-list-item-title>
            </template>

            <!-- BRAREG -->
            <span v-for="item in items.brareg" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule && currentPath == item.path ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule && currentPath == item.path ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>

          <v-list-group :value="true" no-action v-if="show_admin_menu">
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("global.sb_admin_menu") }}</v-list-item-title>
            </template>

            <!-- ADMIN -->
            <span v-for="item in items.admin" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>
        </v-list>
      </v-layout>
    </v-layout>
    <!-- <span class="version">{{ $getAppVersion() }}</span> -->
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Sidebar",

  created() {
    let navdrawer = Boolean(window.innerWidth >= this.SIDEBAR_MOBILEBREAKPOINT_WIDTH)
    this.$toggleDrawer(navdrawer)
  },

  computed: {
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    currentModule: {
      get() {
        return this.$store.getters["master/currentModule"]
      }
    },
    currentPath: {
      get() {
        return this.$store.getters["master/currentPath"].replace("app", "")
      }
    },
    show_brakomp_menu() {
      let bool = false
      let items = this.items.brakomp
      items.forEach((item) => {
        if (item.show) {
          bool = true
        }
      })

      return bool
    },
    show_brareg_menu() {
      let bool = false
      let items = this.items.brareg
      items.forEach((item) => {
        if (item.show) {
          bool = true
        }
      })

      // return bool
      return false
    },
    show_admin_menu() {
      let bool = false
      let items = this.items.admin
      items.forEach((item) => {
        if (item.show) {
          bool = true
        }
      })

      return bool
    },
    items: {
      get() {
        return {
          main: [
            {
              icon: "dashboard",
              text: this.$i18n.t("dashboard.title"),
              path: "dashboard",
              module: "dashboard",
              show: true
            },
            {
              icon: "domain",
              text: this.$t("organisations.title"),
              path: "organisations",
              module: "organisations",
              show: this.$can("organisation-access")
            },
            {
              icon: "dns",
              text: this.$t("tennants.title"),
              path: "tennants",
              module: "tennants",
              show: this.$can("tennant-access")
            },
            {
              icon: "accessibility",
              text: this.$t("persons.title"),
              path: "persons",
              module: "persons",
              show: this.$can("person-access")
            },
            {
              icon: "content_paste",
              text: this.$t("reports.title"),
              path: "reports",
              module: "reports",
              show: true
            },
            {
              icon: "menu_book",
              text: this.$t("global.manuals"),
              path: "manuals",
              module: "manuals",
              show: true
            },
            {
              icon: "settings",
              text: this.$t("settings.title"),
              path: "settings",
              module: "settings",
              show: this.$can("setting-access")
            }
          ],
          brakomp: [
            {
              icon: "school",
              text: this.$t("educationprograms.title"),
              path: "educationprograms",
              module: "educationprograms",
              show: this.$can("educationprogram-access")
            },
            {
              icon: "assessment",
              text: this.$t("coursetemplates.title"),
              path: "coursetemplates",
              module: "coursetemplates",
              show: this.$can("coursetemplate-access")
            },
            {
              icon: "group_work",
              text: this.$t("coursetypegroups.title"),
              path: "coursetypegroups",
              module: "coursetypegroups",
              show: this.$can("coursetypegroup-access")
            },
            {
              icon: "list_alt",
              text: this.$t("coursetypes.title"),
              path: "coursetypes",
              module: "coursetypes",
              show: this.$can("coursetype-access")
            },
            {
              icon: "vertical_split",
              text: this.$t("moduletemplates.title"),
              path: "moduletemplates",
              module: "moduletemplates",
              show: this.$can("moduletemplate-access")
            },
            {
              icon: "local_offer",
              text: this.$t("notificationtemplates.title"),
              path: "notificationtemplates",
              module: "notificationtemplates",
              show: this.$can("notificationtemplate-access")
            },
            {
              icon: "notifications_active",
              text: this.$t("notifications.title"),
              path: "notifications",
              module: "notifications",
              //show: this.$can("notification-access")
              show: this.user.email == "aevin.rabago@gmail.com" || this.user.email == "vitali@avalia.no" || this.user.email == "lars@noorsi.no"
            },
            {
              icon: "class",
              text: this.$t("classes.title"),
              path: "classes",
              module: "classes",
              show: this.$can("class-access")
            }
          ],
          brareg: [
            {
              icon: "list_alt",
              text: this.$t("checklist.properties"),
              path: "checklist/properties",
              module: "checklist",
              show: this.$can("checklisttemplate-access")
            },
            {
              icon: "description",
              text: this.$t("checklist.forms"),
              path: "checklist/builder",
              module: "checklist",
              show: this.$can("checklisttemplate-access")
            },
            {
              icon: "list_alt",
              text: this.$t("checklisttemplatecategory.module"),
              path: "equipmentchecklists",
              module: "checklisttemplatecategory",
              show: this.$can("checklisttemplatecategory-access")
            }
          ],
          admin: [
            {
              icon: "view_compact",
              text: this.$t("customergroups.title"),
              path: "customergroups",
              module: "customergroups",
              show: this.$can("customergroup-access")
            },
            {
              icon: "person",
              text: this.$t("users.title"),
              path: "users",
              module: "users",
              show: this.$can("user-access")
            },
            {
              icon: "recent_actors",
              text: this.$t("roles.title"),
              path: "roles",
              module: "roles",
              show: this.$can("role-access")
            },
            {
              icon: "recent_actors",
              text: this.$t("tenantroles.title"),
              path: "tenantroles",
              module: "tenantroles",
              show: this.$can("tenantrole-access")
            },
            {
              icon: "vpn_key",
              text: this.$t("permissions.title"),
              path: "permissions",
              module: "permissions",
              show: this.user.email == "aevin.rabago@gmail.com" || this.user.email == "vitali@avalia.no"
            },
            {
              icon: "priority_high",
              text: this.$t("logs.title"),
              path: "logs",
              module: "logs",
              show: this.$can("log-access")
            },
            {
              icon: "integration_instructions",
              text: this.$t("integrations.title"),
              path: "integrations",
              module: "integrations",
              show: this.$hasRole("system-developer")
            },
            {
              icon: "integration_instructions",
              text: this.$t("modules.title"),
              path: "modules",
              module: "modules",
              show: this.$hasRole("system-developer")
            },
            {
              icon: "manage_history",
              text: this.$t("changelog.title"),
              path: "changelog",
              module: "changelog",
              show: true,
            }
            /*{
                            icon: "queue",
                            text: this.$t("queues.title"),
                            path: "queues",
                            module: "queues",
                            show: this.$can("queue-access")
                        }*/
          ]
        }
      }
    },

    drawer: {
      get() {
        return this.$store.getters["master/drawerOpen"]
      },
      set() {}
    }
  },

  methods: {
    redirect(to) {
      if (to == "manuals") {
        window.open("https://rise.articulate.com/share/XZdHtKGCE7c9jgIyFirjxJ-VoWf4Ipmm#/", "_blank")
      } else {
        this.$router.push(this.BACKEND_URL + "/" + to)
      }
    },

    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]

      return paths.some((path) => {
        return this.$router.path.indexOf(path) === 0 // current path starts with this path string
      })
    },

    drawerClose(obj) {
      if (!obj) {
        this.$store.dispatch("master/setDrawerOpen", false)
      }
    }
  }
}
</script>

<style scoped></style>
